import React from "react";
import PropTypes from "prop-types";
import withSnack from "./withSnack";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Hidden
} from "@material-ui/core/";
import IconButton from '@material-ui/core/IconButton/IconButton'
import { Add, Remove } from '@material-ui/icons'
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import SettingStore from '../stores/SettingStore'

export class ListHistoryPermissions extends React.Component {
  state = {
    registers: []
  };

  onClose = () => {
    this.props.onClose();
  }

  getHistory = () => {
    SettingStore.historyPermissions().then(r => {
      this.setState({ registers: r.data })
    })
    .catch( error => {
      this.setState({ registers: 0 })
    });
  }

  componentDidMount(){
    this.getHistory();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open === false && (prevProps.open !== this.props.open)) {
        this.getHistory();
    }
  }


  render() {
    const { open } = this.props;
    const { registers } = this.state;

    let history = <Typography variant="body1" gutterBottom align="center">Historial vacío</Typography>;
    if (registers.length > 0){
      history = (
        <Table padding="dense" spacing={0} align="nowrap">
          <TableHead>
            <TableRow>
              <Hidden smDown>
                <TableCell>Otorga el permiso</TableCell>
                <TableCell>Fecha/Hora</TableCell>
              </Hidden>
              <TableCell>Recibe el permiso</TableCell>
              <TableCell>Tipo permiso</TableCell>
              <TableCell>Acción realizada</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {registers.map(r => {
            return (
              <TableRow key={r.id}>
                <Hidden smDown>
                  <TableCell>{r.admin}</TableCell>
                  <TableCell>{r.date}</TableCell>
                </Hidden>
                <TableCell>{r.user}</TableCell>
                <TableCell>{r.permission === 'Create'? 'Crear oficios' :  'Otorgar Permisos'}</TableCell>
                <TableCell align="center">{r.action === 'Dar'? <Add color="action"/> : <Remove color="action"/> }</TableCell>
              </TableRow>
            )
          })}
          </TableBody>
        </Table>);
    }

    return (
      <Dialog aria-labelledby="Permissions" open={open} fullWidth maxWidth="md">
        <DialogTitle style={{textAlign: 'center'}}>Historial de permisos
          <IconButton onClick={this.onClose} className="close_fix_button" >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>
        <DialogContent style={{paddingBottom: "10px"}} className="modal_sessions">
          {history}
        </DialogContent>
      </Dialog>
    );
  }
}

ListHistoryPermissions.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default withSnack(ListHistoryPermissions);



// WEBPACK FOOTER //
// ./src/components/ListHistoryPermissions.js